// Presentation preferences ONLY. Per the hard boundary, localStorage never holds
// sessions, CSRF, tokens, or PII — just non-sensitive display prefs.
const KEYS = {
  lastOrgId: "epidev.lastOrgId",
  lastAdminPath: "epidev.lastAdminPath",
  compactTables: "epidev.compactTables",
  theme: "epidev.theme"
} as const;

export type AdminLandingPath =
  | "/admin/entitlements"
  | "/admin/revenue"
  | "/admin/organizations"
  | "/admin/audit"
  | "/admin/discord"
  | "/admin/contracts"
  | "/admin/contract-queue";

function read(key: string): string | null {
  try {
    return globalThis.localStorage?.getItem(key) ?? null;
  } catch {
    return null;
  }
}

function write(key: string, value: string | null): void {
  try {
    if (value === null) globalThis.localStorage?.removeItem(key);
    else globalThis.localStorage?.setItem(key, value);
  } catch {
    /* private mode / disabled storage — prefs are best-effort */
  }
}

function readAdminPath(): AdminLandingPath {
  const value = read(KEYS.lastAdminPath);
  return value === "/admin/organizations" || value === "/admin/revenue" || value === "/admin/audit" || value === "/admin/discord"
    || value === "/admin/contracts" || value === "/admin/contract-queue"
    ? value
    : "/admin/entitlements";
}

class Prefs {
  lastOrgId = $state<string | null>(read(KEYS.lastOrgId));
  lastAdminPath = $state<AdminLandingPath>(readAdminPath());
  compactTables = $state<boolean>(read(KEYS.compactTables) === "1");
  theme = $state<"dark">("dark");

  setLastOrg(orgId: string | null): void {
    this.lastOrgId = orgId;
    write(KEYS.lastOrgId, orgId);
  }

  setLastAdminPath(path: AdminLandingPath): void {
    this.lastAdminPath = path;
    write(KEYS.lastAdminPath, path);
  }

  toggleCompact(): void {
    this.compactTables = !this.compactTables;
    write(KEYS.compactTables, this.compactTables ? "1" : "0");
  }
}

export const prefs = new Prefs();
